import store from '@/vuex'
import socket from '@/plugins/socket'
import Tools from '@/utils/Tools'

if (sessionStorage.getItem('isProjectMode')) {
  store.commit('SET_ADMIN_PROJECT_MODE', true)
}

function goToMenu (to, next) {
  if (to.name === 'main') {
    const menuList = store.getters.menuList
    if (menuList.length && menuList[0].sub_menu.length) {
      next({ name: menuList[0].sub_menu[0].menuName })
    } else if (menuList.length) {
      next({ name: menuList[0].menuName })
    } else {
      next()
    }
  } else {
    next()
  }
}

/**
 * 这里可以做页面拦截，很多后台系统中也非常喜欢在这里面做权限处理
 * @param {Object} to
 * @param {Object} from
 * @param {Function} next
 */
export function routerBeforeEachFunc (to, from, next) {
  // 数据上报
  window._hmt && window._hmt.push(['_trackPageview', `${location.pathname}#${to.path}`])

  if (to.query.token && to.query.userId && to.query.projectId) {
    const newToken = to.query.token.replace(/\s/g, '+')
    const userId = to.query.userId
    const companyId = Tools.getCookie('companyId')
    const projectId = to.query.projectId
    sessionStorage.setItem('UserId', userId)
    sessionStorage.setItem('companyId', companyId)
    sessionStorage.setItem('E-User-Token', newToken)
    store.commit('SET_ADMIN_PROJECT_MODE', true)
    sessionStorage.setItem('isProjectMode', '1')
    localStorage.setItem('selectedProject_' + userId, projectId)
  }
  store.commit('SET_ROUTER_LOADING', true)
  let token = sessionStorage.getItem('E-User-Token')
  if (to.meta.requiresAuth) {
    if (token) {
      const requestList = []
      if (!store.getters.settingData.config) {
        requestList.push(store.dispatch('FetchConfig'))
      }
      if (!store.getters.menuList) {
        requestList.push(store.dispatch('GetMenuList'))
      }
      if (!store.getters.operationList) {
        requestList.push(store.dispatch('GetOperationList'))
      }
      if (!store.getters.user) {
        requestList.push(store.dispatch('GetUserInfo'))
      }
      if (!store.getters.company) {
        requestList.push(store.dispatch('GetCompanyInfo'))
      }
      if (requestList.length) {
        Promise.all(requestList).then(() => {
          if (!store.getters.user.isAdmin) {
            const projectId = localStorage.getItem('selectedProject_' + store.getters.user.id)
            socket.connect(token, projectId)
          }
          goToMenu(to, next)
        }).catch(e => {
          console.log(e)
        })
      } else {
        goToMenu(to, next)
      }
    } else {
      next({ path: '/login' })
    }
  } else {
    if (to.matched.some(record => record.meta.requireAuth)) {
      // 校验 userID
      let useId = sessionStorage.getItem('UserId')
      let flag = false
      let regPos = /^\d+(\.\d+)?$/ // 非负浮点数
      if (regPos.test(useId)) {
        flag = true
      } else {
        flag = false
      }
      if (flag === false) {
        next({ path: '/login' })
      } else {
        next()
      }
    } else {
      next()
    }
  }
}

/**
 * @param {Object} to
 * @param {Object} from
 * @param {Function} next
 */
export function routerAfterEachFunc (to, from, next) {
  store.commit('SET_ROUTER_LOADING', false)
}



// WEBPACK FOOTER //
// ./src/config/router.js